import axios from "axios";
import {apiConfig} from "~/utils/constants";

export const imbalancesApi = {
    getZonesAndRotation: async (type, pair) => {
        const result = { data: null, error: null };
        try {
            const res = await axios.get(`${apiConfig.QUANT_BASE_API_URL}/${pair}/${type}`, {
                timeout: 30000
            });

            if (res.status === 200) {
                result.data = res.data;
            } else {
                result.error = res;
            }
        } catch (err) {
            result.error = err;
        }
        return result;
    }
};
